<template>
  <div>
    <div class="cate_info" v-if="thumbnail && thumbnail.url">
      <v-lazy-img
        width="100%"
        :src="(thumbnail && thumbnail.thumbnail) || defaultImage"
        :data-url="thumbnail.url"
        alt
        class="img-fluid"
      />
    </div>
    <div class="cate_text_mb container" v-if="thumbnail && thumbnail.url">
      <h3>{{ name }}</h3>
      <span class="tinymce-content" v-html="description"></span>
    </div>
    <div
      class="athena-product-list container"
      :class="product_list_wildscreen ? 'product_list_wildscreen' : ''"
      id="athena-product-list"
    >
      <div class="athena_list-header text-center" v-if="!thumbnail">
        <h5 class="title title_font2">
          {{ name == 'Products' && 
              pageData.pathName &&
              pageData.pathName.toUpperCase() === 'ALL' ? $t("productList.products") : name }}
        </h5>
        <div
          v-if="description"
          v-html="description"
          class="tinymce-content default_css page_text_font athena_list-header-description"
        ></div>
      </div>
      <div class="product-list" :class="[filter_onoff ? 'filter_flex' : '',`model_${product_list_layout}`]">
        <div
          class="d-none d-md-block"
          :class="{
            'col-md-1-5': product_list_layout === '4columns',
            'col-md-3': product_list_layout === '3columns',
            'col-md-4': product_list_layout === '2columns',
          }"
          v-if="filter_onoff"
          :style="{ paddingTop: show_sort_selector ? '20px' : '' }"
        >
          <v-productFilter
            :product_filter="product_filter_res"
            :api_get_product="api_get_product"
            theme="athena"
          ></v-productFilter>
        </div>
        <div class="row " :class="{ 'margin-0': filter_onoff ,'product-list__box':filter_onoff}" :style="products_list && products_list.length?'overflow: hidden':''">
          <div class="list-sort col-12" :class="{'zindex9999': filter_add_zindex}" style="padding: 0 17.5px">
            <v-shortSort
              :show_star="product_cart_style && product_cart_style.show_star"
              v-if="show_sort_selector"
            ></v-shortSort>
            <div class="d-block d-md-none" v-if="filter_onoff">
              <v-productFilter
                :product_filter="product_filter_res"
                :api_get_product="api_get_product"
                theme="athena"
              ></v-productFilter>
            </div>
          </div>
          <div class="row p-1-7d5 full-p col-12" style="margin: 0; flex: 1; padding:0;">
            <template v-if="products_list && products_list.length">
              <div
                v-for="list in products_list"
                :key="list.ID"
                class="p-1-7d5 p-md-1-15"
                :class="{
                  'col-md-3 col-6': product_list_layout === '4columns',
                  'col-md-4 col-6': product_list_layout === '3columns',
                  'col-md-6 col-6': product_list_layout === '2columns',
                  full: product_list_mobile_layout === '1columns',
                  half_full: product_list_mobile_layout === '2columns',
                }"
              >
                <v-product-card
                  theme="athena"
                  :card_animate="
                    product_cart_style && product_cart_style.card_animate
                  "
                  :buy_button_style="
                    product_cart_style && product_cart_style.buy_button_style
                  "
                  :text_align="
                    product_cart_style && product_cart_style.text_align
                  "
                  :product_price="
                    product_cart_style && product_cart_style.product_price
                  "
                  :card_radio="
                    product_cart_style && product_cart_style.card_radio
                  "
                  :cart_type="cart_type"
                  :sales_label="
                    product_cart_style && product_cart_style.sales_label
                  "
                  :currency_style="currency_style"
                  :show_currency_selector="show_currency_selector"
                  :productDetail="list"
                  :layout="product_list_layout"
                  :disable_select="true"
                  :show_star="
                    product_cart_style && product_cart_style.show_star
                  "
                  :sale_image="
                    product_cart_style && product_cart_style.sale_image
                  "
                  :sale_image_show="
                    product_cart_style && product_cart_style.sale_image_show
                  "
                  model="is_card"
                  :custom_button="
                    is_custom_button &&((
                    list.custom_button &&
                    list.custom_button.custom_button)||(
                    mix_custom_button_list &&
                    mix_custom_button_list[list.ID] &&
                    mix_custom_button_list[list.ID]['custom_button']))
                  "
                  :palette_config="palette_config"
                  :product_list_layout="product_list_layout"
                  :filter_onoff="filter_onoff"
                  combination_position="productList"
                ></v-product-card>
              </div>
            </template>
            <div v-else style="width: 100%">
              <h5 class="page_text_font text-center">
                {{
                  filter_onoff
                    ? $t("filter.not_results")
                    : $t("productList.no_products")
                }}
              </h5>
            </div>
          </div>
          <v-paging
            style="width: 100%"
            v-if="products_page.last_page > 1"
            :total="products_page.last_page"
            :currentPage="products_page.current_page"
            :path="products_page.path"
            :sortvalue="sortvalue"
            theme="showtime"
            type="sort"
          ></v-paging>
        </div>
      </div>
      <slot name="modules-list"></slot>
    </div>
  </div>
</template>

<script>
import vShortSort from "../../../../../js/components/view/shortSort/shortSort.vue";
import vPaging from '@/views/venue/js/view/collections/Paging'
import mixFilter from "@/js/mixins/mixFilter";
import { mapActions } from "vuex";
import mixGetPlugs from "@/js/mixins/mixGetPlugs"
import { urlToQueryData } from '@/js/lib/util';

export default {
  props: [
    "currency_style",
    "tags",
    "products",
    "name",
    "collectionsslug",
    "name",
    "product_cart_style",
    "cart_type",
    "show_currency_selector",
    "show_sort_selector",
    "product_list_layout",
    "description",
    "product_filter",
    "is_custom_button",
    "product_palette",
    "palette_config",
    "product_list_wildscreen",
    "thumbnail",
    "keep_top",
    "list_transparent_head",
    "product_list_mobile_layout",
    "combination_config",
    "product_tag",
  ],
  data() {
    return {
      sortvalue: "manual",
      products_list: [],
      products_ids: [],
      products_page: {},
      filter_add_zindex: false,
      pageData: urlToQueryData(location.href),
    };
  },
  mixins: [mixFilter,mixGetPlugs],
  methods: {
    fixed_filter() {
      let window_scroll = this.$(window).scrollTop();
      let header = this.$(".section-header"); // 整个头部
      let notice = this.$(".section-header-notice"); // 公告栏
      let nav = this.$(".site-header"); // 导航栏
      let notice_height = notice.height() || 0; // 公告栏高度
      let nav_height = nav.height() || 0; // 导航栏高度
      let fixed_top = 0; // 用于处理头部导航固定的总高度
      let list_header_height =
        (this.$("div.athena_list-header").outerHeight() || 0) +
        (this.$("div.cate_info").outerHeight() || 0) +
        (this.$("div.cate_text_mb").outerHeight() || 0);
      let quick_nav = this.$("div.quick-nav"); //快捷导航
      let quick_nav_height = quick_nav.outerHeight() || 0; //快捷导航的高度
      // 头部导航固定时处理
      if (header.css("position") == "fixed") {
        fixed_top = notice_height + nav_height + quick_nav_height;
      } else if (notice.css("position") == "fixed") {
        fixed_top = notice_height;
      } else if (nav.css("position") == "fixed") {
        fixed_top = nav_height;
      }
      if (quick_nav.css("position") == "fixed") {
        fixed_top = fixed_top + quick_nav_height;
      }
      if (
        window.innerWidth < 750 &&
        this.keep_top &&
        window_scroll >
          list_header_height +
            notice_height +
            ((!this.list_transparent_head && nav_height) || 0) -
            fixed_top
      ) {
        this.$("div.list-sort").css({
          position: "fixed",
          left: 0,
          top: fixed_top,
          zIndex: 100,
          background: "#fff",
        });
      } else {
        this.$("div.list-sort").css({
          position: "static",
          left: 0,
          top: "unset",
          zIndex: "unset",
        });
      }
    },
    Resize() {
      if (window.innerWidth < 750 && this.keep_top) {
        window.addEventListener("scroll", this.fixed_filter, true);
      } else {
        window.removeEventListener("scroll", this.fixed_filter);
      }
    },
    ...mapActions({
      get_product_tag: "change_product_tag_list", //获取产品tag
      get_product_palette: "get_product_palette", //获取产品调色板
      get_combination_list: "get_combination_list", // 将 `this.get_product_tag()` 映射为 `this.$store.dispatch('change_product_tag_list')`
    }),
  },
  mounted() {
    this.Resize();
    window.onresize = () => {
      this.Resize();
    };
    if (
      this.$("div.transparent_head").length > 0 &&
      !this.thumbnail
    ) {
      this.$("#athena-product-list").addClass("athena_top");
    }
    this.send_fb_event("ViewCategory", { content_name: this.name });
  },
  beforeMount() {
    this.products_page = this.products;
    const url = window.location.search;
    const urlArr = url.substr(1).split("&");
    const urlObj = {};
    urlArr.forEach((item) => {
      const arr = item.split("=");
      const [key, value] = arr;
      urlObj[key] = value;
    });
    this.sortvalue = urlObj.sort || "manual";
    this.bus.$on("change_filter_zindex", (drawer) => {
      this.filter_add_zindex=drawer;
    });
  },
  watch: {
    products_page: {
      handler(newV, oldV) {
        let { data } = newV;
        if (!data) {
          this.products_list = [];
          this.products_ids = [];
          return;
        }
        this.products_list = data;
        this.products_ids = [];
        data.forEach((item) => {
          this.products_ids.push(item.ID);
        });
        if (this.product_tag) {
          this.get_product_tag(this.products_ids);
        }
        if (this.combination_config) {
          this.get_combination_list({
            'filter[product_ids]': this.products_ids.join(','),
            ...this.formatSearch(),
            combination_position: "productList"
          })
        }
        if (this.palette_config) {
          this.get_product_palette(this.products_ids)
        }
      },
      immediate: true,
    },
  },
  components: {
    vShortSort,
    vPaging,
  },
};
</script>

<style lang="scss" scoped>
@media screen and(min-width: 768px) {
  .product_list_wildscreen {
    max-width: unset !important;
    padding-left: 50px;
    padding-right: 50px;
    .filter_flex {
      margin-right: 0;
    }
    .product-list {
      & > .col-md-2.d-none.d-md-block {
        width: 230px;
        flex: unset;
        margin-right: 65px;
      }
    }
  }
}
.athena-product-list {
  margin-bottom: 100px;
  .athena_list-header {
    padding: 30px 35px;
    .title {
      line-height: 49px;
      font-weight: 400;
      font-style: normal;
      color: #454545;
      transition: color 0.2s ease-in-out;
      font-size: 30px;
      letter-spacing: 2px;
      margin-bottom: 12px;
    }
    .athena_list-header-description {
      max-width: 530px;
      margin: 0 auto;
      line-height: 1.65;
    }
  }
  .product-list {
    .list-sort {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 42px;
    }
    &::v-deep {
      .p_list_2 {
        .product_title {
          font-size: 20px !important;
          text-align: left;
          line-height: unset;
          margin-bottom: 14px;
        }
        p {
          text-align: left;
          .selectpricewrap {
            line-height: 1;
            .money {
              font-size: 20px !important;
            }
            .product_price_cross {
              float: left;
              margin-left: 0;
              font-size: 20px;
            }
          }
        }
        .ahtena_star {
          font-size: 20px;
          text-align: left;
          margin-top: 22px;
          line-height: unset;
          .starWrap {
            .el-rate__item {
              margin-right: 2px !important;
              margin-left: -4px !important;
            }
            .el-rate {
              height: auto;
            }
            .el-rate__icon {
              font-size: 29px !important;
              color: #000 !important;
            }
            .el-rate__decimal {
              color: #000 !important;
            }
          }
        }
      }
      .p_list_3 {
        .product_title {
          font-size: 20px !important;
          text-align: left;
          line-height: unset;
          margin-bottom: 14px;
        }
        p {
          text-align: left;
          .selectpricewrap {
            line-height: 1;
            .money,
            .product_price_price,
            .product_price_cross {
              font-size: 20px !important;
            }
            .product_price_cross {
              float: left;
              margin-left: 0;
              font-size: 20px;
            }
          }
        }
        .ahtena_star {
          font-size: 20px;
          text-align: left;
          margin-top: 22px;
          line-height: unset;
          .starWrap {
            .el-rate__item {
              margin-right: 2px !important;
              margin-left: -4px !important;
            }
            .el-rate {
              height: auto;
            }
            .el-rate__icon {
              font-size: 29px !important;
              color: #000 !important;
            }
            .el-rate__decimal {
              color: #000 !important;
            }
          }
        }
      }
      .p_list_4 {
        .product_title {
          font-size: 18px !important;
          text-align: left;
          line-height: unset;
          margin-bottom: 13px;
        }
        p {
          text-align: left;
          .selectpricewrap {
            line-height: 1;
            .money,
            .product_price_price,
            .product_price_cross {
              font-size: 18px !important;
            }
            .product_price_cross {
              float: left;
              margin-left: 0;
            }
          }
        }
        .ahtena_star {
          font-size: 18px;
          text-align: left;
          margin-top: 20px;
          line-height: unset;
          .starWrap {
            .el-rate__item {
              margin-right: 2px !important;
              margin-left: -4px !important;
            }
            .el-rate {
              height: auto;
            }
            .el-rate__icon {
              font-size: 20px !important;
              color: #000 !important;
            }
            .el-rate__decimal {
              color: #000 !important;
            }
          }
        }
      }
      .p_list_5 {
        .product_title {
          font-size: 16px !important;
          text-align: left;
          line-height: unset;
          margin-bottom: 13px;
        }
        p {
          text-align: left;
          .selectpricewrap {
            line-height: 1;
            .money,
            .product_price_price,
            .product_price_cross {
              font-size: 16px !important;
            }
            .product_price_cross {
              float: left;
              margin-left: 0;
            }
          }
        }
        .ahtena_star {
          font-size: 16px;
          text-align: left;
          margin-top: 16px;
          line-height: unset;
          .starWrap {
            .el-rate__item {
              margin-right: 2px !important;
              margin-left: -4px !important;
            }
            .el-rate {
              height: auto;
            }
            .el-rate__icon {
              font-size: 20px !important;
              color: #000 !important;
            }
            .el-rate__decimal {
              color: #000 !important;
            }
          }
        }
      }
      .pagination {
        margin: 60px 0 0;
        .page-item:not(:last-child) {
          margin-right: 4px;
        }
      }
      .athena_shortSort {
        display: inline;
        font-size: 20px;
        margin-bottom: 60px;
      }
      .athena_hidden,
      .athena_shortSort_mb {
        display: none;
      }
      .pc-header header h5 {
        font-size: 20px;
        margin-bottom: 21px;
        color: #222a40;
      }
      @media screen and (max-width: 768px) {
        .p_list_2,
        .p_list_3,
        .p_list_4 {
          .product_title {
            font-size: 15px !important;
            margin-bottom: 14px;
          }
          p {
            .selectpricewrap {
              .money,
              .product_price_price,
              .product_price_cross {
                font-size: 14px !important;
              }
              .product_price_cross {
                font-size: 14px;
              }
            }
          }
          .ahtena_star {
            font-size: 13px;
            margin-top: 8px;
            .starWrap {
              .el-rate__item {
                margin-right: 1px !important;
                margin-left: -1px !important;
              }
              .el-rate__icon {
                font-size: 14px !important;
              }
            }
          }
        }
        .pagination {
          margin: 30px 0 0;
          .page-item {
            font-size: 12px;
          }
        }
        .athena_shortSort {
          display: none;
        }
        .athena_shortSort_mb {
          display: inline;
        }
        .full-p {
          padding: 0 !important;
        }
        .full {
          flex: 0 0 100%;
          max-width: 100%;
          padding: 0 !important;
          > div {
            box-shadow: 0px 4px 16px 0px rgba(108, 108, 108, 0.35);
            .product_details {
              padding: 15px;
              margin-top: 0;
            }
          }
        }
        .half_full {
          flex: 0 0 50%;
          max-width: 50%;
          > div {
            box-shadow: 0px 4px 16px 0px rgba(108, 108, 108, 0.35);
            .product_details {
              padding: 15px;
              margin-top: 0;
            }
          }
          &:nth-child(2n + 1) {
            padding-left: 0;
          }
          &:nth-child(2n) {
            padding-right: 0;
          }
        }
      }
    }
  }
}

.cate_info {
  position: relative;
  overflow: hidden;
  font-family: Roboto-Regular;
  .cate_text {
    max-width: 34%;
    width: 100%;
    position: absolute;
    bottom: 5.2vw;
    left: 8.33vw;
    color: #fff;
    h3 {
      font-size: calc(20px + 1.04vw);
      color: #222222;
      line-height: inherit;
      margin-bottom: 3.12vw;
    }
    span {
      font-size: calc(14px + 0.52vw);
      line-height: calc(26px + 0.52vw);
      color: #3a3a3a;
    }
  }
}
.cate_text_mb {
  padding: 40px 30px 80px;
  h3 {
    font-family: "TenorSans";
    font-size: 40px;
    color: #222222;
    line-height: inherit;
    margin-bottom: 40px;
    font-weight: 500;
  }
  span {
    font-family: Roboto;
    font-size: 18px;
    line-height: 18px;
    color: #3a3a3a;
  }
}

.margin-0 {
  margin: 0 !important;
}

.athena_top {
  padding-top: 80px !important;
}

.zindex9999 {
  z-index: 9999 !important;
  position: fixed !important;
}

@media screen and (min-width: 767px) {
  .filter_flex {
    display: flex;
    margin-right: -15px;
    margin-left: -15px;
    align-items: flex-start;
    & > div:last-child {
      flex: 1;
      max-width: 75%;
    }
  }
  .model_4columns{
    .product-list__box {
      max-width: 80% !important;
    }
  }
  .model_3columns{
    .product-list__box {
      max-width: 75% !important;
    }
  }
  .model_2columns{
    .product-list__box {
      max-width: 66.6666% !important;
    }
  }
}

@media screen and (max-width: 767px) {
  #athena-product-list {
    margin-bottom: 50px;
    .athena_list-header {
      .title {
        font-size: 18px;
        line-height: 29px;
        margin-bottom: 12px;
      }
    }
    .product-list {
      .list-sort {
        display: flex;
        justify-content: space-between;
        margin-bottom: 12px;
        box-shadow: 1px 1px #e3e3e3, -1px -1px #e3e3e3;
        -webkit-box-shadow: 1px 1px #e3e3e3, -1px -1px #e3e3e3;
        &::v-deep .sort-select {
          flex: 1;
          text-align: center;
          .sort-select-btn {
            padding: 13px 0;
          }
        }
        .d-block.d-md-none {
          flex: 1;
          &::v-deep .product-filter {
            .productFileterMb {
              .filter-mb-onoff {
                .main_button {
                  background-color: white !important;
                  color: #333 !important;
                  padding: 13px 0;
                  font-size: 14px;
                  font-family: Muli-Bold !important;
                  line-height: 23px;
                }
              }
            }
          }
        }
        & > div:nth-child(2) {
          border-left: 1px solid #e3e3e3;
        }
      }
    }
  }
  .cate_text {
    display: none;
  }
  .cate_text_mb {
    padding: 14px 15px 14px;
    h3 {
      font-family: "TenorSans";
      font-size: 20px;
      color: #222222;
      line-height: inherit;
      margin-bottom: 14px;
    }
    span {
      font-family: Roboto;
      font-size: 13px;
      line-height: 18px;
      color: #3a3a3a;
    }
  }
  .athena_top {
    padding-top: 60px !important;
  }
}
@media screen and (max-width: 575px) {
}
</style>
